import { useAuth } from "@/contexts/AuthContext";
import type { ReactNode } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles?: string[];
}

export function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-brand-off-white flex items-center justify-center">
        <div className="animate-pulse text-brand-azul-profundo">
          Carregando...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login, saving the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role-based access
  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return (
      <div className="min-h-screen bg-brand-off-white flex items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-2xl font-serif font-semibold text-brand-azul-profundo mb-4">
            Acesso não autorizado
          </h1>
          <p className="text-slate-600 mb-6">
            Você não tem permissão para acessar esta página.
          </p>
          <Link
            to="/dashboard"
            className="text-brand-azul-profundo hover:underline"
          >
            Voltar para o painel
          </Link>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

export default ProtectedRoute;
